<script>
import api from '../../../api'
import Meditator from './Meditator'
import Audio from '../../Utils/Audio/index.vue'

export default {

  name: "Meditation",

  components: { Meditator, Audio },

  props: [ "meditation" ],

  data() {
    return {
      states: {},
      meditators: {},
      past_phrases: [],
      phrases: [],
      selected_track: null
    }
  },


  computed: {

    title() { return this.meditation.Title },
    sections() { return this.meditation.Body },
    fallbackMessage() { return this.meditation.FallbackMessage },
    count() { return Object.keys( this.meditators ).length },

    meditators_array() {
      return Object.values( this.meditators )
    },
    m_online() {
      return this.meditators_array.filter( m => m.state != 0 )
    },
    m_connected() {
      return this.meditators_array.filter( m => m.state == 1 )
    },
    m_queuing() {
      return this.meditators_array.filter( m => m.state == 2 )
    },
    m_meditating() {
      return this.meditators_array.filter( m => m.state == 3 )
    },
    m_meditated() {
      return this.meditators_array.filter( m => m.state == 4 )
    },
    current_meditator() {
      let meditator
      if ( this.m_meditating.length ) {
        meditator = this.m_meditating[0]
        this.$store.commit( 'styles/reset', meditator.colors[0].h )
      } else {
        meditator = null
      }
      return meditator
    },

    current_track() {
      if ( this.current_meditator && this.phrases.length ) {
        return this.get_phrase_by_id( this.current_meditator.phrase )
      } else if ( this.selected_track ) {
        return this.selected_track
      } else {
        return null
      }
    },

    current_audio() {
      return this.current_track && this.current_track.audio
    }

  },

  async created() {
    this.phrases = await api.phrases.getAll()
    this.$socket.client.connect()
  },

  beforeUnmount() {
    this.$socket.client.disconnect()
  },

  sockets: {

    connect() {
      console.log( 'socket connected as', this.$socket.client.id )
    },

    welcome( { meditators, states, past_phrases } ) {
      this.states = states
      for ( const meditator of meditators ) {
        this.set_meditator( meditator )
      }
      if ( past_phrases.length ) {
        this.past_phrases = past_phrases.map( id =>{
          return this.phrases.find( p => p.id == id )
        })
      }
    },

    meditator( meditator ) {
      this.set_meditator( meditator )
    },

  },

  methods: {
    set_meditator( meditator ) {
      meditator.state = meditator._STATE
      if ( meditator.state === 0 ) {
        delete this.meditators[ meditator.id ]
      } else {
        this.meditators[ meditator.id ] = meditator
      }
      console.log( meditator.id, 'set state', meditator.state, this.states[ meditator.state ] )
    },
    get_phrase_by_id( id ) {
      return this.phrases.find( p => p.id == id )
    },
    handle_select_track( id ) {
      console.log(id)
      if ( !this.current_meditator ) {
        this.selected_track = this.get_phrase_by_id( id )
      }
    }
  }

}
</script>

<template>
  <div
    id="meditation"
    aria-label="The meditation quadrant"
    tabindex="0"
  >
    <div
      class="meditation_ongoing"
      v-if="count"
    >
      <Audio
        :audio="current_audio"
        :track="current_track"
        :past_phrases="past_phrases"
        @select_track="handle_select_track( $event )"
        @ended="selected_track = null"
      />
      <!-- <div class="meditators connected">
        <p> Connected meditators </p>
        <transition-group name="fade" appear>
          <Meditator
            v-for="meditator in m_connected"
            :key="meditator.id"
            :meditator="meditator"
            :style="{ '--n' : Math.random() }"
          />
        </transition-group>
      </div> -->
      <div class="meditators queueing">
        <!-- <p> Queue </p> -->
        <transition-group name="fade" appear>
          <Meditator
            v-for="meditator in m_queuing"
            :key="meditator.id"
            :meditator="meditator"
            :style="{ '--n' : Math.random() }"
          />
        </transition-group>
      </div>
      <div class="meditators meditated">
        <!-- <p> Done </p> -->
        <transition-group name="fade" appear>
          <Meditator
            v-for="meditator in m_meditated"
            :key="meditator.id"
            :meditator="meditator"
            :style="{ '--n' : Math.random() }"
          />
        </transition-group>
      </div>
      <transition name="fade" appear>
        <Meditator
          v-if="current_meditator"
          class="current"
          :meditator="current_meditator"
          :style="{ '--n' : Math.random() }"
        />
      </transition>
    </div>
    <div
      v-else
      tabindex="0"
      class="fallback"
    >
      <div>
        <p>
          <span>
            {{ fallbackMessage }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
#meditation {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  /* filter: url(#noise); */
}

.meditators {
  width: 50%;
  /* height: 100%; */
  display: flex;
  align-items: center;
  align-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  /* background-color: var(--dark1); */
  position: absolute;
  min-height: 15vh;
  max-height: 30vh;
}
.meditators.queueing {
  top: 0; left: 0;
}
.meditators.meditated {
  top: 0; left: 50%;
  justify-content: flex-end;
}





.meditation_ongoing >>> .audioContainer {
  right: calc( 50% - var(--width) / 2 );
  width: 100%;
  z-index: 0;
  padding: 50px;
}
.meditation_ongoing >>> .audioContainer .controls {
  justify-content: flex-end;
  width: 100%;
}
.meditation_ongoing >>> .audioContainer .captions {
  --width:  clamp( 0%, 100%, 70em );
  width: var(--width);
  height: 100vh;
  position: absolute;
  bottom: 0;
  padding-bottom: 15rem;
  pointer-events:all !important;

}
.meditation_ongoing >>> .audioContainer .cue {
  font-size: calc(26pt * var(--sizeFactor));
}
.isMobile .meditation_ongoing >>> .audioContainer {
  height: 100vh;
  padding: 1.25em;
}
.isMobile .meditation_ongoing >>> .audioContainer .controls {
  justify-content: flex-end;
  width: 100%;
}
.isMobile .meditation_ongoing >>> .audioContainer .captions {
  padding-left: 3rem;
  padding-bottom: 15rem;
  pointer-events:all !important;
}

.isMobile .meditation_ongoing >>> .audioContainer .cue {
  /* font-size: 1.5rem; */
  font-size: calc(18pt * var(--sizeFactor));
}

.fallback {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  z-index: 1;
  text-align: center;
}
.fallback div {
  margin: auto;
  max-width: 40em;
  z-index: 0;
}
.fallback div span {
  background: var(--dark2);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.fade-enter-active {
  transition-delay: calc( 1s * var(--n) );
}
.fade-leave-active {
  position: absolute;
}

</style>
